import { FaWhatsapp } from "react-icons/fa6"
import { FaLinkedin , FaInstagram } from "react-icons/fa"
import { MdOutlineMail } from "react-icons/md"
import { IoLogoFacebook } from "react-icons/io5"


export const navbarLinks = [
    {
        title : "Quem Somos?",
        link : "#about"
    },
    {
        title : "Serviços",
        link : "#servicos"
    },
    {
        title : "Parceiros",
        link : "#parceiros"
    },
    {
        title : "Contato",
        link : "#contato"
    },
]

export const carousselsContent = [
  {
    title: "Mapeamento e Análise de Processos",
    description:
      "Transforma processos lentos em operações ágeis, identificando falhas, gargalos e oportunidades de melhoria.",
  },
  {
    title: "Plano de Negócios",
    description:
      "Oferecemos orientação especializada para tomada de decisões estratégicas, ajudando empresas a planejar crescimento, otimizar recursos e aumentar a competitividade no mercado.",
  },
  {
    title: "Planejamento",
    description:
      "Desenvolvemos planos estratégicos personalizados para otimizar operações e alcançar objetivos de longo prazo.",
  },
  {
    title: "Plano de Marketing ",
    description:
      "Elaboramos planos de marketing eficazes para promover produtos e serviços, aumentando a visibilidade e as vendas.",
  },
  {
    title: "Estratégico Plano de Cargos e Salários ",
    description:
      "Implementamos sistemas de remuneração justos e motivacionais, alinhados com a estratégia da empresa.",
  },
  {
    title: "Pesquisa e Análise de Mercado ",
    description:
      "Realizamos pesquisas detalhadas para entender o mercado, concorrentes e consumidores, fornecendo insights valiosos para decisões estratégicas.",
  },
  {
    title: "Pesquisa de Satisfação",
    description:
      "Avaliamos a satisfação de clientes e funcionários para identificar áreas de melhoria e fortalecer relacionamentos.",
  },
  {
    title: "Precificação Persuasiva",
    description:
      "Desenvolvemos estratégias de precificação que maximizam lucros e atraem clientes, considerando valor percebido e concorrência.",
  },
]



export const contactLinks = [
  {
    icon: MdOutlineMail,
    title: "ej.semfronteiras@gmail.com",
    link : "mailto:ej.semfronteiras@gmail.com"
  },
  {
    icon: FaWhatsapp,
    title: " (49) 9 99411627",
    link : "https://wa.me/5549999411627"
  },
  {
    icon: FaInstagram,
    title: "semfronteirasjr",
    link : "https://www.instagram.com/semfronteirasjr/"
  },
  {
    icon: FaLinkedin,
    title: "Sem Fronteiras Consultoria Jr",
    link : "#"
  },
  {
    icon: IoLogoFacebook,
    title: "Sem Fronteiras Consultoria Junior",
    link : "https://www.facebook.com/SemFronteirasConsultoriaJr/?locale=pt_BR"
  },
]
